import {
  createStyles,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Theme,
} from "@material-ui/core"
import React from "react"
import { useHistory } from "react-router-dom"
import { Settings as SettingsIcon, Home as HomeIcon } from "@material-ui/icons"

export type Props = {
  open: boolean
  setOpen: (open: boolean) => void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      minWidth: 250,
    },
  })
)

const MenuDrawer: React.FC<Props> = ({
  open: menuOpen,
  setOpen: setMenuOpen,
}) => {
  const classes = useStyles()
  const history = useHistory()

  const navigate = (url: string): void => {
    history.push(url)
    setMenuOpen(false)
  }

  return (
    <Drawer anchor="left" open={menuOpen} onClose={() => setMenuOpen(false)}>
      <List className={classes.list}>
        <ListItem
          data-qa-selector="home-item"
          button
          onClick={() => navigate("/")}
        >
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText>Home</ListItemText>
        </ListItem>
        <ListItem
          data-qa-selector="settings-item"
          button
          onClick={() => navigate("/settings")}
        >
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText>Settings</ListItemText>
        </ListItem>
      </List>
    </Drawer>
  )
}

export default MenuDrawer
